import {
  Edit,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  ImageInput,
  ImageField,
  LongTextInput,
  translate
} from "react-admin";
import React from "react";

const SOSTitle = ({ translate, record }) => {
  return <span>{`${translate("sos.sos")}`}</span>;
};

const Title = translate(SOSTitle);

export const SosEdit = props => {
  const project = localStorage.getItem("project");
  return (
    <Edit title={<Title />} {...props}>
      <SimpleForm {...props}>
        <ReferenceInput
          disabled
          defaultValue={project}
          source="project"
          reference="project"
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput disabled source="room" reference="room">
          <SelectInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput
          disabled
          label="ผู้ใช้งาน"
          source="user"
          reference="user"
        >
          <SelectInput
            optionText={value => `${value.email} ${value.provider || ""}`}
          />
        </ReferenceInput>
        <ReferenceInput disabled source="user" reference="user">
          <SelectInput optionText="mobile" />
        </ReferenceInput>
        <SelectInput
          source="status"
          choices={[
            { id: 0, name: "Open" },
            { id: 1, name: "Followup" },
            { id: 2, name: "Closed" }
          ]}
        />

        {/* <ReferenceInput disabled label="ประเภทข้อมูล" source="type_data" reference="sostypedata">
                    <SelectInput optionText="name" />
                </ReferenceInput>
                <ReferenceInput disabled label="ข้อมูล" source="type" reference="sostype">
                    <SelectInput optionText="name" />
                </ReferenceInput>
                <ImageField source="images" src="url" label="images" />
                <LongTextInput disabled source="description" /> */}
      </SimpleForm>
    </Edit>
  );
};



// WEBPACK FOOTER //
// ./src/components/sos/SosEdit.js